<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div
            v-if="loading"
            class="my-8 align-self-stretch d-flex align-center justify-center"
        >
            <Spinner />
        </div>
        <div v-if="!loading">
            <div class="ufv-container-text">
                <div class="text-h4" v-if="novoUsuarioInstitucional">
                    Novo Usuário Institucional
                </div>
                <div class="text-h4" v-if="!novoUsuarioInstitucional">
                    Editar Usuário Institucional
                </div>
            </div>
            <v-form ref="form" v-model="formValido" class="mt-8">
                <v-container>
                    <v-row>
                        <v-text-field
                            label="Nome"
                            v-model="usuarioInstitucional.nome"
                            :rules="formRules.nome"
                        />
                    </v-row>
                    <v-row>
                        <v-text-field
                            label="E-mail"
                            v-model="usuarioInstitucional.email"
                            :rules="formRules.email"
                        />
                    </v-row>
                    <v-row
                        ><multi-select-guardiao
                            v-model="usuarioInstitucional.usuarios"
                    /></v-row>
                    <v-row class="botoes flex-start">
                        <v-btn
                            color="primary"
                            @click="salvar()"
                            :disabled="!salvavel"
                            :loading="salvando"
                        >
                            <v-icon class="mr-2">mdi-content-save</v-icon>
                            Salvar
                        </v-btn>
                        <v-btn text @click="cancelar()"> Cancelar </v-btn>
                        <v-btn
                            v-if="!novoUsuarioInstitucional"
                            color="error"
                            text
                            @click="promptApagar()"
                            :loading="apagando"
                        >
                            <v-icon class="mr-2">mdi-delete</v-icon>
                            Apagar
                        </v-btn>
                    </v-row>
                </v-container>
            </v-form>
            <alerta-modal v-model="mostrarDialogo" :tipo="tipoDialogo">{{
                msgDialogo
            }}</alerta-modal>
            <yes-cancel-dialog
                v-model="mostrarYesCancelDialog"
                @ok="yesCancelDialogResolver('ok')"
                @cancelar="yesCancelDialogResolver('cancelar')"
                >{{ msgYesCancelDialog }}</yes-cancel-dialog
            >
        </div>
    </v-container>
</template>

<script>
import Spinner from "../../../componentes/ui/Spinner.vue";
import MultiSelectGuardiao from "./MultiSelectGuardiao.vue";
import AlertaModal from "../../../componentes/AlertaModal.vue";
import YesCancelDialog from "../../../componentes/YesCancelDialog.vue";
import debounce from "lodash/debounce";
import {
    getServicoUsuarioInstitucional,
    getServicoGuardiao,
} from "../../../services/ServicosFactory";

const servicoUsuarioInstitucional = getServicoUsuarioInstitucional();
const servicoGuardiao = getServicoGuardiao();

export default {
    name: "UsuarioInstitucionalForm",
    components: {
        Spinner,
        "alerta-modal": AlertaModal,
        "multi-select-guardiao": MultiSelectGuardiao,
        "yes-cancel-dialog": YesCancelDialog,
    },
    data() {
        return {
            loading: true,
            formValido: true,
            nomeJaExiste: false,
            verificandoNome: false,
            salvando: false,
            apagando: false,
            mostrarDialogo: false,
            tipoDialogo: "sucesso",
            msgDialogo: "",
            mostrarYesCancelDialog: false,
            msgYesCancelDialog: "",
            yesCancelDialogResolver: null,
            usuarioInstitucional: {
                id: null,
                nome: "",
                email: "",
                usuarios: [],
            },
            formRules: {
                nome: [
                    (v) => !!v || "Este campo é obrigatório",
                    (v) => v.trim().length > 0 || "Este campo é obrigatório",
                    () =>
                        !this.nomeJaExiste ||
                        "Já existe um usuário institucional com este nome",
                ],
                email: [
                    (v) =>
                        !v ||
                        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
                        "E-mail inválido",
                ],
            },
        };
    },
    async mounted() {
        if (this.$route.params.id) {
            const usuarioInstitucional =
                await servicoUsuarioInstitucional.obterUsuarioInstitucionalPorId(
                    this.$route.params.id,
                );
            usuarioInstitucional.usuarios =
                await servicoGuardiao.hidratarUsuarios(
                    usuarioInstitucional.usuarios,
                );
            usuarioInstitucional.email =
                (usuarioInstitucional.config &&
                    usuarioInstitucional.config.email) ||
                "";
            this.usuarioInstitucional = usuarioInstitucional;
        }
        this.loading = false;
    },
    computed: {
        novoUsuarioInstitucional() {
            return !this.$route.params.id;
        },
        salvavel() {
            return this.formValido && !this.verificandoNome;
        },
    },
    watch: {
        "usuarioInstitucional.nome": {
            handler: debounce(function (novoNome) {
                if (!novoNome || !novoNome.trim()) {
                    this.nomeJaExiste = false;
                    this.verificandoNome = false;
                    return;
                }
                this.verificandoNome = true;
                if (this.novoUsuarioInstitucional) {
                    servicoUsuarioInstitucional
                        .usuarioInstitucionalExiste(novoNome)
                        .then((existe) => {
                            this.nomeJaExiste = existe;
                            this.$refs.form.validate();
                        })
                        .finally(() => {
                            this.verificandoNome = false;
                        });
                } else {
                    servicoUsuarioInstitucional
                        .obterUsuarioInstitucionalPorNome(novoNome)
                        .then((usuariosInstitucionais) => {
                            this.nomeJaExiste = usuariosInstitucionais.some(
                                (u) =>
                                    u.nome === novoNome &&
                                    u.id !== this.usuarioInstitucional.id,
                            );
                        })
                        .finally(() => {
                            this.$refs.form.validate();
                            this.verificandoNome = false;
                        });
                }
            }, 300),
            immediate: false,
        },
    },
    methods: {
        salvar() {
            this.salvando = true;
            const { usuarios, ...usuarioInstitucional } =
                this.usuarioInstitucional;
            const usuarioInstitucionalParaSalvar = {
                ...usuarioInstitucional,
                cpfs: usuarios.map((usuario) => usuario.cpf),
            };
            servicoUsuarioInstitucional
                .salvarUsuarioInstitucional(usuarioInstitucionalParaSalvar)
                .then((usuarioInstitucional) => {
                    this.usuarioInstitucional = usuarioInstitucional;
                    this.mostrarSucesso(
                        "Usuário institucional salvo com sucesso!",
                    );
                    this.$router.push({ name: "UsuarioInstitucionalAdmin" });
                })
                .catch((err) => {
                    console.error("Erro ao salvar", err);
                    this.mostrarErro("Falha ao salvar usuário institucional!");
                })
                .finally(() => {
                    this.salvando = false;
                });
        },
        cancelar() {
            this.$router.push({ name: "UsuarioInstitucionalAdmin" });
        },
        promptApagar() {
            this.msgYesCancelDialog =
                "Tem certeza que deseja apagar este usuário institucional?";
            this.mostrarYesCancelDialog = true;
            new Promise((resolve) => {
                this.yesCancelDialogResolver = resolve;
            })
                .then((resultado) => {
                    if (resultado === "ok") {
                        return this.apagar();
                    }
                    return "cancelado";
                })
                .then((resultado) => {
                    if (resultado !== "cancelado") {
                        this.mostrarSucesso(
                            "Usuário institucional apagado com sucesso!",
                        );
                        this.$router.push({
                            name: "UsuarioInstitucionalAdmin",
                        });
                    }
                })
                .catch((err) => {
                    console.error("Erro ao apagar", err);
                    this.mostrarErro("Falha ao apagar usuário institucional!");
                })
                .finally(() => {
                    this.mostrarYesCancelDialog = false;
                    this.msgYesCancelDialog = "";
                    this.yesCancelDialogResolver = null;
                });
        },
        apagar() {
            this.apagando = true;
            return servicoUsuarioInstitucional
                .apagarUsuarioInstitucional(this.usuarioInstitucional)
                .finally(() => {
                    this.apagando = false;
                });
        },
        mostrarErro(msg) {
            this.tipoDialogo = "erro";
            this.msgDialogo = msg;
            this.mostrarDialogo = true;
        },
        mostrarSucesso(msg) {
            this.tipoDialogo = "sucesso";
            this.msgDialogo = msg;
            this.mostrarDialogo = true;
        },
    },
};
</script>
